import Dialog from '@material-ui/core/Dialog';
import { makeStyles, Theme } from '@material-ui/core/styles';
import UpsertBoxDialog from 'adminForm/UpsertBoxDialog';
import React from 'react';
import { AdminDialogState } from './Admin';

interface Props {
  dialog: AdminDialogState;
  closeDialog: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: { height: '90%', width: '80%', maxWidth: '800px' },
}));

const AdminDialog = ({ dialog, closeDialog }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={dialog.isOpen}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        classes={{ paper: classes.paper }}
      >
        <UpsertBoxDialog dialog={dialog} closeDialog={closeDialog} />
      </Dialog>
    </div>
  );
};

export default AdminDialog;
